<template>
    <div>
        <div v-if="chartOnly">
            <b-progress
                :max="100"
                :variant="getColorVariant(successRate)"
                show-progress
                class="mb-2"
            >
                <b-progress-bar
                    :value="Number(successRate)"
                    :label="`${successRate.toFixed(1)}%`"
                ></b-progress-bar>
            </b-progress>
        </div>
        <div v-else class="order-results">
            <div class="d-flex align-items-center">
                <font-awesome-icon icon="poll-h" size="3x" />
                <div class="flex-fill">
                    <h5>
                        {{ $t("Overall Results") }} ({{
                            successRate.toFixed(1)
                        }}% Pass)
                    </h5>
                    <b-progress
                        :max="100"
                        :variant="getColorVariant(successRate)"
                        show-progress
                        class="mb-2"
                    >
                        <b-progress-bar
                            :value="Number(successRate)"
                            :label="`${successRate.toFixed(1)}%`"
                        ></b-progress-bar>
                    </b-progress>
                    <div class="legend">
                        {{ $t("Pass total") }}: {{ pass }}
                        <span class="mx-1">&middot;</span>
                        {{ $t("Fail total") }}: {{ fail }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.order-results {
  .svg-inline--fa {
    opacity: 0.6;
    margin-right: 1.25rem;
  }
  .legend {
    font-size: 0.8rem;
  }
}
</style>

<script>
import { getColorVariant } from "../../plugins/utilities";
export default {
  props: {
    chartOnly: {
      type: Boolean,
      default: false
    },
    total: {
      type: Number,
      default: 0
    },
    pass: {
      type: Number,
      default: 0
    },
    fail: {
      type: Number,
      default: 0
    },
    successRate: {
      type: Number,
      default: 0
    }
  },
  methods: {
    getColorVariant: getColorVariant
  }
};
</script>
